<template>
  <BaseAction>
    <RemoveTalentPoolDialog @close="closeDialog" v-if="isOpen" />
    <SecondaryButton @click.native="openDialog" textColor="#d10a3a">
      <v-icon>
        mdi-delete-outline
      </v-icon>
      Delete Pool
    </SecondaryButton>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import RemoveTalentPoolDialog from "@/views/workers/TalentPools/dialogs/RemoveTalentPoolDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "RemoveTalentPoolAction",
  components: {
    SecondaryButton,
    RemoveTalentPoolDialog,
    BaseAction
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
